"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarChartContext = void 0;
var react_1 = __importDefault(require("react"));
// Context that allows bars to pass sizing information to their parent
exports.BarChartContext = react_1.default.createContext({
    updateYLabelSize: function () { return undefined; },
});
